import { render, staticRenderFns } from "./QuotesCarousel.vue?vue&type=template&id=3487994e&"
import script from "./QuotesCarousel.vue?vue&type=script&lang=js&"
export * from "./QuotesCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/T7/BACKUP/repositories/reveil-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3487994e')) {
      api.createRecord('3487994e', component.options)
    } else {
      api.reload('3487994e', component.options)
    }
    module.hot.accept("./QuotesCarousel.vue?vue&type=template&id=3487994e&", function () {
      api.rerender('3487994e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/QuotesCarousel.vue"
export default component.exports